export const ENV_TYPE = {
  WEAPP: 'WEAPP',
  WEB: 'WEB',
  RN: 'RN',
  SWAN: 'SWAN',
  ALIPAY: 'ALIPAY',
  TT: 'TT',
  QQ: 'QQ',
  JD: 'JD'
}

let _env = null

// 一个taro项目肯定运行同样的环境
export function getEnv () {
  if (_env) return _env
  if (typeof jd !== 'undefined' && jd.chooseImage) {
    _env = ENV_TYPE.JD
    return ENV_TYPE.JD
  }
  if (typeof qq !== 'undefined' && qq.chooseImage) {
    _env = ENV_TYPE.QQ
    return ENV_TYPE.QQ
  }
  if (typeof tt !== 'undefined' && tt.chooseImage) {
    _env = ENV_TYPE.TT
    return ENV_TYPE.TT
  }
  if (typeof wx !== 'undefined' && wx.chooseImage) {
    _env = ENV_TYPE.WEAPP
    return ENV_TYPE.WEAPP
  }
  if (typeof swan !== 'undefined' && swan.chooseImage) {
    _env = ENV_TYPE.SWAN
    return ENV_TYPE.SWAN
  }
  if (typeof my !== 'undefined' && my.chooseImage) {
    _env = ENV_TYPE.ALIPAY
    return ENV_TYPE.ALIPAY
  }
  if (typeof global !== 'undefined' && global.__fbGenNativeModule) {
    _env = ENV_TYPE.RN
    return ENV_TYPE.RN
  }
  if (typeof window !== 'undefined') {
    _env = ENV_TYPE.WEB
    return ENV_TYPE.WEB
  }
  return 'Unknown environment'
}
